import React, { useCallback } from "react";

import { useAppState } from "Context/StateContext";
import { useTranslation } from "react-i18next";
import { Route, Switch, useLocation } from "react-router-dom";

import { Menu } from "./Menu";
import {
  AsideWrapper,
  CompanyName,
  CompanyNameWrapper,
  CompanyTitle,
  HeaderContainer,
  HeaderContent,
  HeaderWrapper,
  ImageLogo,
  StyledCustomerName,
} from "./styled";

const CustomerPortalHeader = () => {
  const { currentCustomerUser, subDomainInfo } = useAppState();
  const { t: translate } = useTranslation();
  const location = useLocation();

  const returnImageLogoOrCompanyName = useCallback(() => {
    if (subDomainInfo?.logo) return <ImageLogo src={subDomainInfo?.logo} />;

    return (
      <CompanyNameWrapper>
        <CompanyName>{subDomainInfo?.name}</CompanyName>
      </CompanyNameWrapper>
    );
  }, [subDomainInfo]);

  return (
    <>
      <HeaderContainer isHeaderInsideJobPage={location.pathname.includes("/job")}>
        <HeaderWrapper id="header">
          <HeaderContent>
            {returnImageLogoOrCompanyName()}

            <AsideWrapper>
              <Menu />
            </AsideWrapper>
          </HeaderContent>
        </HeaderWrapper>
      </HeaderContainer>

      <Switch>
        <Route exact path="/jobs/:jobIdToken">
          <CompanyTitle>
            <StyledCustomerName>{`${translate("hi")} ${
              currentCustomerUser?.fullName
            },`}</StyledCustomerName>
          </CompanyTitle>
        </Route>
      </Switch>
    </>
  );
};

export { CustomerPortalHeader };
